import { render, staticRenderFns } from "./GrazingTab.vue?vue&type=template&id=fba0db0e&scoped=true&"
import script from "./GrazingTab.vue?vue&type=script&lang=js&"
export * from "./GrazingTab.vue?vue&type=script&lang=js&"
import style1 from "./GrazingTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0db0e",
  null
  
)

export default component.exports